export function toPascalCaseWithSpace(inputString) {
    const words = inputString?.split(/\s+/);
    const pascalCaseWords = words && words?.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    const pascalCaseString = pascalCaseWords?.join(' ');
    return pascalCaseString;
  }

export function truncateRaceType(name) {
  if (!name) return "-";
  const parts = name.split(" ");
  if (parts.length > 0) {
    parts[0] = parts[0].substring(0, 4);
  }
  return parts.join(" ");
}

export function formatDateStandard(date) {
  if (!date) return "-";
  const d = new Date(date);
  if (isNaN(d.getTime())) return "-";
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function toTitleCase(str) {
  if (!str) return "-";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}